export default "__VITE_ASSET__CaLZpvEY__"